import { Id } from "storefront/lib/Id";
import { Conversation } from "storefront/Conversation";
import { get } from "storefront/GrailedAPI/request";

export type Metadata = {
  unreadCount: number;
};

/**
 * https://www.grailed.com/internal/api-docs#operation/getConversation
 */
type Response = {
  data: Conversation;
  metadata: Metadata;
};

const unpack = (res: Response): [Conversation, Metadata] => [
  res.data,
  res.metadata,
];

const findById = (id: Id): Promise<[Conversation, Metadata]> =>
  get<Response>(`/api/conversations/${id}`).then(unpack);

export default findById;
